import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { ThingsToDoSection } from '../../components/ThingsToDoSection';
import { useLocationContext } from '../../context';

import { DestinationEvent } from '@eventbrite/event-renderer';
import { Organizer } from '../../components/OrganizersSection';
import { Places } from '../NearbyCities';
import { Trending } from '../TrendingSearches';

import {
    NearbyCitiesSection,
    TopEventsSection,
    TopOrganizersSection,
    TrendingSearchesSection,
} from './AccordionSection';

import './FAQSection.scss';

interface HeaderProps {
    text: string | GenericLazyString;
}

export interface FAQSectionProps {
    topEventsBucket: DestinationEvent[];
    topOrganizersBucket: Organizer[];
    nearbyCitiesBucket: Places;
    trendingSearchesBucket: Trending;
}

const FAQHeader: React.FunctionComponent<HeaderProps> = (props) => {
    const { text } = props;
    return (
        <div className="ttd_faq_section-header--title">
            <p className="eds-text-hs">{text}</p>
        </div>
    );
};

export const FAQSection: React.FunctionComponent<FAQSectionProps> = (props) => {
    const { shortPlaceName } = useLocationContext();
    const headerText = gettext(
        'Frequently asked questions about %(shortPlaceName)s',
        { shortPlaceName: shortPlaceName },
    );
    const showFaqSection =
        props.topEventsBucket.length > 0 ||
        props.topOrganizersBucket.length > 0 ||
        props.nearbyCitiesBucket.length > 0 ||
        props.trendingSearchesBucket.length > 0;
    // each section will conditionally render, if their associated bucket exists.

    return showFaqSection ? (
        <section
            className="ttd_faq_section-container"
            itemScope
            itemType="https://schema.org/FAQPage"
        >
            <ThingsToDoSection>
                <FAQHeader text={headerText} />
                <div className="ttd-faq-accordion-section">
                    {props.topEventsBucket.length > 0 && (
                        <TopEventsSection data={props.topEventsBucket} />
                    )}
                    {props.topOrganizersBucket.length > 0 && (
                        <TopOrganizersSection
                            data={props.topOrganizersBucket}
                        />
                    )}
                    {props.nearbyCitiesBucket.length > 0 && (
                        <NearbyCitiesSection data={props.nearbyCitiesBucket} />
                    )}
                    {props.trendingSearchesBucket.length > 0 && (
                        <TrendingSearchesSection
                            data={props.trendingSearchesBucket}
                        />
                    )}
                </div>
            </ThingsToDoSection>
        </section>
    ) : (
        <></>
    );
};
